/**
 * Central app registry for the QI Tech app switcher.
 *
 * Each entry:
 *   name         — Display name
 *   url          — Dashboard URL
 *   iconName     — MUI icon name (rendered in component)
 *   description  — Tooltip / subtitle text
 *   color        — Brand gradient for the icon background
 */

const isSandbox =
  process.env.REACT_APP_ENV === 'sandbox' ||
  process.env.REACT_APP_ENV === 'local' ||
  process.env.REACT_APP_ENV === 'dev';

const QI_APPS = [
  {
    name: 'Risk Solutions',
    url: isSandbox
      ? 'https://dash.sandbox.caas.qitech.app/'
      : 'https://dash.caas.qitech.app',
    iconName: 'security',
    description: 'Risk Solutions Dashboard',
    color: { from: '#3B5CFE', to: '#4FCCED' },
  },
  {
    name: 'CertifiQI',
    url: isSandbox
      ? 'https://beta.sandbox.certifiqi.com.br'
      : 'https://beta.certifiqi.com.br',
    iconName: 'assignment',
    description: 'Certifier Dashboard',
    color: { from: '#F5AD45', to: '#FD5B77' },
  },
  {
    name: 'QI Sign',
    url: isSandbox
      ? 'https://dash.sandbox.sign.qitech.com.br/'
      : 'https://dash.sign.qitech.com.br/',
    iconName: 'edit',
    description: 'QI Sign Dashboard',
    color: { from: '#3ED485', to: '#4FCCED' },
  },
  {
    name: 'QI SCD',
    url: isSandbox
      ? 'http://sandbox.qitech.app/'
      : 'https://qitech.app/',
    iconName: 'account_balance',
    description: 'Banking Solutions Dashboard',
    color: { from: '#6C63FF', to: '#3B5CFE' },
  },
];

export default QI_APPS;
